import { del, post, get, put } from './api_helper';
import { prepareSearch } from './SearchUtils';

export const getNotificationsListApi = (query = {}) =>
    get(`/notification?${prepareSearch(query)}`);
